import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './browser-detection.component.scss';
var BrowserDetection = /** @class */ (function (_super) {
    tslib_1.__extends(BrowserDetection, _super);
    function BrowserDetection(element) {
        var _this = _super.call(this, element) || this;
        _this.event.register('openModal', _this, _this.openModal.bind(_this));
        return _this;
    }
    BrowserDetection.prototype.init = function () {
        if (this.isIE() && this.isIE() < 10) {
            this.openModal();
        }
    };
    BrowserDetection.prototype.bindEvents = function () { };
    BrowserDetection.prototype.openModal = function () {
        this.modal = this.element.querySelector('#browser-detection-modal-1');
        this.modal.classList.remove('modal--close');
        this.modal.classList.remove('modal--closed');
    };
    BrowserDetection.prototype.isIE = function () {
        var browser = navigator.userAgent.toLowerCase();
        // return (browser.indexOf('msie') != -1) ? parseInt(browser.split('msie')[1]) : false;
        return 9; // To test modal
    };
    return BrowserDetection;
}(Base));
export { BrowserDetection };



//////////////////
// WEBPACK FOOTER
// ./components/browser-detection/browser-detection.component.ts
// module id = 155
// module chunks = 0